import { SadmProtocol } from '@pixacare/dtos';
import { Form, FormReport, getReport } from '@pixacare/forms';

// An entity's care protocols, newest first: the backend does not guarantee any ordering on the
// history. A sadm client without a protocol creation form has no protocol to report on.
export const toProtocolReports = (protocolsHistory: SadmProtocol[], protocolForm?: Form): FormReport[] => {
  if (!protocolForm) {
    return [];
  }

  return (protocolsHistory ?? [])
    .map((protocol) => ({
      ...getReport(protocolForm, protocol.protocolCreationFormAnswer),
      date: protocol.createdOn,
      createdBy: protocol.createdByInstance,
    }))
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
};
